


































import Vue, { PropType } from 'vue'
import { Message, MessageType } from '@/interfaces/app/Message'
import createMessage from '@/services/app/createMessage'

export default Vue.extend({
  data() {
    return {
      MessageType,
    }
  },
  computed: {
    messages(): Message[] {
      return this.$store.getters['app/messages']
    },
    hasMessages(): boolean {
      return Boolean(this.messages.length)
    },
  },
  methods: {
    getMessageIcon(messageType: MessageType): string {
      switch (messageType) {
        case MessageType.Info:
          return 'fa-question'
          break
        case MessageType.Success:
          return 'fa-check'
          break
        case MessageType.Warning:
          return 'fa-exclamation'
          break
        default:
          return 'fa-exclamation-triangle'
          break
      }
    },
    clearMessage(messageUid: string): void {
      this.$store.dispatch('app/clearMessage', messageUid)
    },
  },
})
